import { render, staticRenderFns } from "./ContactAlreadyExistBlock.vue?vue&type=template&id=ef97ffd4"
import script from "./ContactAlreadyExistBlock.vue?vue&type=script&lang=js"
export * from "./ContactAlreadyExistBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports